import React from 'react'
import Text from '../../components/text/Text'
import WizButton from '../../components/button/WizButton'
import {AI_FEED_CATEGORY_LABEL} from './constants'
import {IFeedItem} from './types'

interface IProps {
    item: IFeedItem | null
    onConfirm: () => void
    onCancel: () => void
}

const ConfirmDeleteModal: React.FC<IProps> = ({item, onConfirm, onCancel}) => {
    if (!item) return null
    return (
        <div className={'fixed inset-0 z-modal flex items-center justify-center'}>
            <div className={'absolute inset-0 bg-black/50'} onClick={onCancel} />
            <div className={'relative z-10 w-[90%] max-w-[480px] bg-white rounded-[8px] p-[24px] shadow-hover'}>
                <Text className={'text-h3 text-font01'}>삭제하시겠습니까?</Text>
                <Text className={'text-ti3 text-font03 mt-[6px]'}>
                    {item.category ? AI_FEED_CATEGORY_LABEL[item.category] : ''}
                </Text>

                <div className={'mt-[24px] flex items-center justify-end gap-x-[10px]'}>
                    <WizButton text={'취소'} onClick={onCancel} />
                    <WizButton text={'삭제'} type={'red'} onClick={onConfirm} />
                </div>
            </div>
        </div>
    )
}

export default ConfirmDeleteModal
